var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 129.7 107",
    style: {
      enableBackground: "new 0 0 129.7 107"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C8DAEA;}\n\t.st1{fill:#A9C6D8;}\n\t.st2{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.6,60.9l14.2,39.4c0,0,1.8,3.7,3.7,3.7s30.3-29.5,30.3-29.5l31.5-60.9L32.1,50.8L31.6,60.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.5,71.1l-2.7,29c0,0-1.1,8.9,7.8,0s17.4-15.8,17.4-15.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.9,62.4L2.6,52.8c0,0-3.5-1.4-2.4-4.6c0.2-0.7,0.7-1.2,2.1-2.2C8.8,41.4,122.4,0.6,122.4,0.6 s3.2-1.1,5.1-0.4c1,0.3,1.7,1.1,1.9,2.1c0.2,0.8,0.3,1.7,0.3,2.6c0,0.8-0.1,1.4-0.2,2.5c-0.7,11.2-21.4,94.5-21.4,94.5 s-1.2,4.9-5.7,5c-2.2,0.1-4.3-0.8-5.9-2.3C87.8,97.2,57.7,76.9,51,72.5c-0.3-0.2-0.5-0.5-0.5-0.9c-0.1-0.5,0.4-1.1,0.4-1.1 s52.4-46.6,53.8-51.5c0.1-0.4-0.3-0.6-0.8-0.4c-3.5,1.3-63.8,39.4-70.5,43.6C32.9,62.4,32.4,62.4,31.9,62.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram_icon.740b7e84c330f008ce6f4ffe0b451f19.svg";
export { ForwardRef as ReactComponent };